import { css, keyframes } from '@emotion/css';
import {
  appColors,
  breakpoints,
  fontFamily,
  shadows,
} from '../../styles/variables.style';

export const container = css`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #fff3e6;
  background-image: radial-gradient(#fbc387 1px, transparent 1px);
  background-size: 30px 30px;
  font-family: ${fontFamily.poppins};
  position: relative;
  overflow: hidden;
  box-sizing: border-box;
`;

export const header = css`
  display: none;
`;

export const logoWrapper = css`
  display: flex;
  align-items: center;
`;

export const logoText = css`
  font-size: 28px;
  font-weight: 800;
  color: #111;
  letter-spacing: -0.5px;
`;

export const headerRight = css`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const signUpBtn = css`
  display: none;
`;

export const requestDemoBtn = css`
  display: none;
`;

export const contentWrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 10px;
  
  @media (max-width: ${breakpoints.md.down}) {
    flex-direction: column;
    padding-top: 20px;
  }
`;

export const decorativeDotsLeft = css`
  position: absolute;
  left: 2%;
  bottom: 10%;
  width: 100px;
  height: 120px;
  background-color: #fed988;
  background-image: radial-gradient(#111 3px, transparent 3px);
  background-size: 25px 25px;
  z-index: 0;

  @media (max-width: ${breakpoints.md.down}) {
    display: none;
  }
`;

export const decorativeDotsRight = css`
  position: absolute;
  right: -30px;
  bottom: -15px;
  width: 120px;
  height: 100px;
  background-color: #fbc387;
  background-image: radial-gradient(#111 3px, transparent 3px);
  background-size: 25px 25px;
  z-index: 0;
`;

export const authContainer = css`
  width: 100%;
  max-width: 400px;
  background: linear-gradient(135deg, #fbc387 0%, #fa9c3e 100%);
  border-radius: 20px;
  padding: 25px;
  box-shadow: 0 10px 30px rgba(241, 102, 2, 0.2);
  position: relative;
  z-index: 5;
  box-sizing: border-box;

  @media (max-width: ${breakpoints.sm.down}) {
    padding: 20px 15px;
  }
`;

export const authHeader = css`
  text-align: center;
  margin-bottom: 15px;

  h2 {
    font-size: 24px;
    font-weight: 800;
    color: #111;
    margin: 0 0 6px;
  }
  
  p {
    font-size: 13px;
    color: #333;
    margin: 0;
    line-height: 1.3;
    font-weight: 500;
  }
`;

export const divider = css`
  display: flex;
  align-items: center;
  text-align: center;
  margin: 15px 0;
  color: #444;
  font-size: 12px;
  font-weight: 600;
  
  &::before, &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid rgba(0,0,0,0.15);
  }
  
  &::before { margin-right: 15px; }
  &::after { margin-left: 15px; }
`;

export const socialButtons = css`
  display: flex;
  flex-direction: row;
  gap: 10px;
  margin-top: 5px;
  justify-content: center;
`;

export const socialBtn = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 40px;
  border-radius: 10px;
  border: none;
  background: #fff;
  font-size: 13px;
  font-weight: 700;
  color: #111;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
  
  svg {
    margin-right: 8px;
  }
  
  &:hover {
    transform: translateY(-2px);
  }
`;

export const footerText = css`
  text-align: center;
  margin-top: 15px;
  font-size: 13px;
  color: #222;
  font-weight: 500;
  
  b {
    color: #111;
    cursor: pointer;
    font-weight: 800;
  }
`;

export const illustrationWrapper = css`
  position: absolute;
  right: 5%;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.9;

  @media (max-width: ${breakpoints.md.down}) {
    display: none;
  }
`;

export const illustrationImage = css`
  width: 260px;
  height: auto;
  position: relative;
  z-index: 1;
`;

export const form = `
  .form-section-header {
    display: none !important;
  }
  
  .input {
    padding: 0 14px !important;
    font-size: 13px !important;
    color: #111 !important;
    background-color: #fff !important;
    border: 2px solid transparent !important;
    border-radius: 10px !important;
    -webkit-box-sizing: border-box;
    font-family: inherit !important;
    height: 44px !important;
    margin-bottom: 12px !important;
    transition: all 0.2s ease;
    box-shadow: 0 4px 8px rgba(0,0,0,0.05) !important;
  }
  
  .input:focus {
    border-color: #111 !important;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
    outline: none !important;
  }
  
  input[name="username"].input, input[type="text"].input, input[type="email"].input, input[type="password"].input {
    background-image: none !important;
  }
  
  .label {
    display: none !important;
  }
  
  .button {
    width: 100%;
    height: 44px;
    background: #111 !important;
    color: #fff !important;
    font-size: 15px;
    font-weight: 700;
    border-radius: 10px !important;
    margin-top: 5px !important;
    border: none;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.2s;
    box-shadow: 0 4px 12px rgba(0,0,0,0.2) !important;
  }
  
  .button:hover {
    opacity: 0.9;
    transform: translateY(-2px);
  }
  
  amplify-button {
    width: 100% !important;
  }
  
  .sign-in-form-footer,
  .sign-up-form-footer {
    font-family: ${fontFamily.poppins} !important;
    color: #222 !important;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
    font-size: 12px !important;
    display: block !important;
    text-align: right !important;
    font-weight: 700 !important;
  }
  
  .anchor {
    color: #111 !important;
    text-decoration: none !important;
    font-weight: 800 !important;
  }
`;
